import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { UserService } from "../../core/services/user/user.service";
import { IActionOdataResult } from "../models/interfaces/action-result.interface";
import { ILookupAssociatedClassProgramChild } from "../models/interfaces/lookup-associated-class-program-child.interface";
import { IParamObj, IParamQuery } from "../models/interfaces/param-query.interface";

@Injectable({
    providedIn: 'root'
})
export class LookupAssociatedClassProgramChildService {

    constructor(private http: HttpClient, private userService: UserService) { }
    /**
     * Returns an array of lookup associated class program children based on http query params
     */
    public get(params?: IParamObj): Observable<Array<ILookupAssociatedClassProgramChild>> {
        const paramQuery: IParamQuery = (params) ? {params: params} : null;
        return this.getPrograms(paramQuery).pipe(map((result) => result.value as Array<ILookupAssociatedClassProgramChild>));
    }

    private getPrograms(paramQuery: IParamQuery): Observable<IActionOdataResult> {
        const httpParams = (paramQuery) ? paramQuery : {};
        return this.http.get<IActionOdataResult>(environment.apiBaseURL + 'odata/LookupAssociatedClassProgramChildren', httpParams)
    }
}
